function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPayouti = function SvgPayouti(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M19.954 16.75v1.659a2.29 2.29 0 0 1-2.287 2.287H5.287A2.29 2.29 0 0 1 3 18.409V9.765a2.29 2.29 0 0 1 2.287-2.287h.219a4.496 4.496 0 0 1 4.482-4.17c1.374 0 2.604.617 3.429 1.59q.27-.047.555-.047a3.28 3.28 0 0 1 3.21 2.627h.484a2.29 2.29 0 0 1 2.287 2.287v1.659a1.25 1.25 0 0 1 1.066 1.237v2.852a1.25 1.25 0 0 1-1.066 1.237zM7.012 7.478h3.749a3.28 3.28 0 0 1 1.194-1.932 2.994 2.994 0 0 0-4.943 1.932m5.307 0h3.305a1.776 1.776 0 0 0-3.305 0m6.134 3.933V9.765a.787.787 0 0 0-.787-.787H5.287a.787.787 0 0 0-.787.787v8.644a.79.79 0 0 0 .787.787h12.379a.79.79 0 0 0 .787-.787v-1.646H16.53a2.05 2.05 0 0 1-2.05-2.05v-1.252a2.05 2.05 0 0 1 2.05-2.05zm1.066 3.852.001-2.352h-2.99a.55.55 0 0 0-.55.55v1.252a.55.55 0 0 0 .55.55z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPayouti);
export default ForwardRef;